import React, { Component } from 'react';
import logo from '../../assets/img/logoImpulseGreenColor.png';
import "./index.scss";
import LineDecoration from '../../assets/images/Line decoration.png';
import { AiFillLinkedin } from 'react-icons/ai';
import { CgInstagram } from 'react-icons/cg';
import { MdEmail } from "react-icons/md";
import { ImInstagram } from "react-icons/im";
import { IoLogoWhatsapp } from "react-icons/io";

class ComingSoon extends Component {
    constructor(props) {
        super(props);
        this.dateRef = React.createRef();
    }


    render() {
        
        // // BELUM SELESAI, BIKIN REF DULU DI CONSTRUCTOR
        // var countDownDate = new Date("Jan 5, 2021 15:37:25").getTime();

        // // Update the count down every 1 second
        // var x = setInterval(function() {

        // // Get todays date and time
        // var now = new Date().getTime();

        // // Find the distance between now an the count down date
        // var distance = countDownDate - now;

        // // Time calculations for days, hours, minutes and seconds
        // var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        // var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        // var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        // var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // // Display the result in an element with id="demo"
        // this.dateRef.innerHTML = days + "d " + hours + "h "
        // + minutes + "m " + seconds + "s ";

        // // If the count down is finished, write some text
        // if (distance < 0) {
        //     clearInterval(x);
        //     document.getElementById("demo").innerHTML = "EXPIRED";
        // }
        // }, 1000);
        return (
            <div className="container container-fluid my-auto centered-area">
                <div className="text-center">
                        <img src={logo} className="mx-auto logo" />
                        <h2 className="my-3 mx-auto text-center">Coming Soon</h2>
                        {/* <img 
                            src={LineDecoration}
                            className="line-decoration"
                            alt="line" 
                        /> */}
                        {/* <p>Nantikan</p> */}
                        {/* <p ref={this.dateRef} className="countdown">35 Days</p> */}
                        <p>Stay connected with us</p>
                        <a href="https://www.instagram.com/impulseitb/"><ImInstagram className="icon"/></a>
                        {/* <a href="#"> <AiFillLinkedin className="icon"/></a>
                        <a href="#"> <MdEmail className="icon"/></a>
                        <a href="#"> <IoLogoWhatsapp className="icon"/></a> */}
                </div>
            </div>
        );
    }
}

export default ComingSoon;